import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import NewFromTemplateIcon from '@material-ui/icons/FileCopyOutlined';
import Warning from '@material-ui/icons/Warning';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import AbilityProvider from '../../permissionsUtils/AbilityProvider';
import * as CardActions from '../../redux/actions/card.actions';
import * as UtilActions from '../../redux/actions/utils.actions.js';
import { BLUE, CREDENTIAL_CATEGORIES, PERMISSIONS, PERMISSION_ENTITIES, RESERVATION_STATUSES, RESERVATION_STATUSES_PARAMETERS, TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import Tag from '../Tag.jsx';
import { CheckCircleOutline } from '@material-ui/icons';
import TimeRangeView from '../Cards/TimeRangeView.jsx';
import { Divider } from '@material-ui/core';
import CredentialActionsMenu from './CredentialActionsMenu.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  guestTag: {
    padding: 3,
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  guestRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowActionButton: {
    width: 40,
    height: 40,
  },
  rowActionButtonIcon: {
    fontSize: 20,
    color: '#E53935',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    width: 'max-content',
  },
  buttonPositive: {
    color: BLUE,
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    marginRight: 10,
    width: 'max-content',
  },
});

@connect((state) => ({ viewLoading: state.utils.viewLoading, credentials: state.credentials, themeName: state.settings.items.theme.data.themeName }))
class CredentialsTableView extends React.Component {

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(CardActions.setOperationalMode(false));
  }

  render() {
    const {
      classes,
      credentials: { data: { data: credentialsData, pagination: { number: currentPage, size, totalPages, totalElements }, filters } },
      credentials: { selectedCredential },
      viewLoading,
      themeName,
      onDeleteCredential,
      onNewCredential,
      onSelectCredential,
      onRefreshCredentials,
      onFetchCredentialsOnPage,
      onCredentialActionSelect,
      onShowInfoModal,
      dispatch
    } = this.props;
    const canCreateNewCredentials = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.CREATE], PERMISSION_ENTITIES.CREDENTIAL_RULE);
    const headerColor = getColorFromThemeName(themeName);
    const validityDateFormat = dispatch(UtilActions.getCredentialValidityDateFormat());
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(credentialsData) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={2}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="platformCredentials" /></h3>
                        <IconButton onClick={() => onRefreshCredentials()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="credentialsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCredentialsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCredentialsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="name" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="authorizedUsers" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="selectedLocks" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="validity" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(credentialsData, (credential) => {
                    const days = credential && credential.daysOfTheWeek && _.orderBy(credential.daysOfTheWeek);
                    const daysOptions = _.map(moment.weekdays(true), weekday => ({
                      label: moment.weekdaysMin(moment().isoWeekday(weekday).isoWeekday()),
                      selected: _.indexOf(days, moment().isoWeekday(weekday).isoWeekday()) !== -1,
                    }));
                    const isInvalidNoTags = _.isEmpty(credential.lockTags) || _.isEmpty(credential.guestTags);
                    const credentialStatus = isInvalidNoTags ? RESERVATION_STATUSES.NO_TAGS : credential.status;
                    const canDeleteCredential = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.CREDENTIAL_RULE);
                    const isPrivacyOverrideActive = credential.openOnPrivacy;

                    return (
                      <TableRow
                        key={credential.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={event => onSelectCredential(credential)}
                        selected={selectedCredential && selectedCredential.id === credential.id}
                      >
                        <TableCell>
                          <div className={classes.guestRowContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{`${credential.name}`}</h5>
                            {credential.description ? <h5 style={{ fontSize: 14, marginTop: 0 }}>{`${credential.description}`}</h5> : null}
                          </div>
                        </TableCell>
                        <TableCell>
                          {_.isEmpty(credential.guestTags) ? (
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <Warning style={{ fontSize: 15, color: 'red', marginTop: 0 }} />
                              <h6 style={{ fontWeight: 'bold', margin: 0, marginLeft: 5, fontSize: 14, color: 'red' }}><Entity entity="emptyTagOrUser" /></h6>
                            </div>
                          ) : (
                            <div className="tags-container">
                              {_.map(credential.guestTags, tag =>
                                <Tag
                                  key={tag.id}
                                  tag={tag}
                                />,
                              )}
                            </div>
                          )}
                        </TableCell>
                        <TableCell>
                          <div className="tags-container">
                            {_.map(credential.lockTags, tag =>
                              <Tag
                                key={tag.id}
                                tag={tag}
                              />)}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.guestRowContainer} style={{ paddingBottom: 6, minWidth: 280, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            {credentialStatus ? (
                              <h5 style={{ fontWeight: 'bold', marginTop: 4, marginBottom: 6 }}>
                                <Entity
                                  key={`status_${credentialStatus}`}
                                  style={{ textTransform: 'uppercase', color: RESERVATION_STATUSES_PARAMETERS[credentialStatus].color }}
                                  entity={RESERVATION_STATUSES_PARAMETERS[credentialStatus].string}
                                />
                              </h5>
                            ) : null}
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 5 }}>
                                {`${moment(credential.dateInterval.from).format(validityDateFormat)} - ${moment(credential.dateInterval.to).format(validityDateFormat)}`}
                              </h5>
                            </div>
                            <div style={{ marginTop: 5 }}>
                              <TimeRangeView timeRange={credential} />
                            </div>
                            {credential.additionalTimeRange ? (
                              <div>
                                <Divider style={{ marginTop: 5 }} />
                                <TimeRangeView
                                  timeRange={credential.additionalTimeRange}
                                />
                              </div>
                            ) : null}
                            {isPrivacyOverrideActive ? (
                              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 7 }}>
                                <CheckCircleOutline style={{ fontSize: 14 }} />
                                <h5 style={{ color: '#3f3f3f', margin: 0, marginLeft: 5 }}>
                                  <Entity entity="privacyOverride" />
                                </h5>
                              </div>
                            ): null}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            {canCreateNewCredentials ? (
                              <CredentialActionsMenu
                                credentialType={CREDENTIAL_CATEGORIES.MOBILE}
                                onActionSelect={(action) => onCredentialActionSelect(credential, action)}
                                buttonStyle={{ marginLeft: 5, marginRight: 10 }}
                              />
                            ) : null}
                            {canDeleteCredential ? (
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onDeleteCredential(credential.id);
                                }}
                                className={classes.button}
                              >
                                <Entity entity="delete" />
                                <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                              </Button>
                            ) : null}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="credentialsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCredentialsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCredentialsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noCredential"
                    onNewEntity={canCreateNewCredentials ? () => onNewCredential() : null}
                    newEntityTitle="addCredential"
                    subtitle="startAddCredentials"
                    iconName="icon-simple-line-icons-user-following"
                    onShowInfo={() => onShowInfoModal()}
                />) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CredentialsTableView);
